import { DEFAULT_HANDLERS, Scanner, ScannerListenerReturnType, ScannerListenerType, ScannerOptions } from '.'

export default class Zebra<CB = any, SR extends ScannerListenerReturnType = ScannerListenerReturnType> implements Scanner {
  listeners: Map<string, any>
  options: ScannerOptions

  constructor (options?: ScannerOptions) {
    this.listeners = new Map()
    this.options = options || {}
  }

  supported () {
    try {
      return false
    } catch (e) {
      return false
    }
  }

  listen<T extends ScannerListenerType = ScannerListenerType> (type: T, success: (data:SR[T]) => void = data => data, error: (error) => void = e => console.error(e)): any | undefined {
    try {
      if (!barcodeManager) {
        return
      }
      return barcodeManager.addReadListner(
        (e: any) => {
          try {
            // const d = JSON.parse(e)
            success({ data: e.barcodeData, type: e.barcodeType})
          } catch (e) {
            console.error('Error during listener success calback', e)
            error(e)
          }
        },
        e => error(e))
    } catch (e) {
      if (e instanceof ReferenceError && e.message?.includes('barcodeManager')) console.warn(`Tried to listen for ${type} events but barcodeManager (global scope) is not defined`)
      else console.error(e)
    }
  }

  mute (type: string) {
    // unexposed on barcodeManager, but internally implemented in onPause
  }

  destroy (id?: string | undefined): void {
    //
  }
}
